import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCurrentCountry } from '../hooks';

const BLOCKED_COUNTRIES = [
  'GH', // Ghana
  'US', // USA
  // European countries
  'AT', // Austria
  'BE', // Belgium
  'BG', // Bulgaria
  'HR', // Croatia
  'CY', // Cyprus
  'CZ', // Czech Republic
  'DK', // Denmark
  'EE', // Estonia
  'FI', // Finland
  'FR', // France
  'DE', // Germany
  'GR', // Greece
  'HU', // Hungary
  'IE', // Ireland
  'IT', // Italy
  'LV', // Latvia
  'LT', // Lithuania
  'LU', // Luxembourg
  'MT', // Malta
  'NL', // Netherlands
  'PL', // Poland
  'PT', // Portugal
  'RO', // Romania
  'SK', // Slovakia
  'SI', // Slovenia
  'ES', // Spain
  'SE', // Sweden
  'GB', // United Kingdom
  'CH', // Switzerland
  'NO', // Norway
  'IS', // Iceland
];
const NO_SERVICE_PATH = '/no-service';

const CountryGate = ({ children }) => {
  const country = useCurrentCountry();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (country) {
      const isBlocked = BLOCKED_COUNTRIES.includes(country.toUpperCase());

      if (isBlocked && location.pathname !== NO_SERVICE_PATH) {
        navigate(NO_SERVICE_PATH, { replace: true });
      }
    }
  }, [country, location.pathname, navigate]);

  return children;
};

export default CountryGate;
